<template>
    <div
      style="overflow-y: auto"
      class="container"
    >
      <!-- <el-button type="primary" style="margin-left: 20px" @click="rechargeBtn">短信充值</el-button> -->
      <div>
        城市：{{ tableData.city_name }}
      </div>
      <!-- <div class="service-box" v-if="recharge_num_info">
              <div>
                  <el-input v-model="amount" style="width: 100px;margin-right:10px"></el-input>（元）

                  <el-button class="service-btn" @click="recharge">确定</el-button>
              </div>
          </div> -->

      <div style="display: flex;justify-content: space-around;margin-top: 10px;">
        <div class="text-container" style="margin-right: 20px;background-color:#edfcff;border: 1px solid #beebe6;">
          <div style="display: flex;justify-content: space-around;">
            <div class="text-box">
              <span>行业短信余额：</span>
              <p class="text" style="color: #14AACF;">{{ tableData.surplus_count }}条</p>
            </div>
            <div class="text-box">
              <span>行业短信预警：</span>
              <p class="text" style="color: #14AACF;">{{ tableData.alert_num }}条</p>
              <el-button
                    size="mini"
                    style="margin-left: 20px;background-color: #fff;color: #14AACF;border: 1px solid #E2EEF1;"
                    type="primary"
                    @click="edit_isShow = !edit_isShow"
                    >设置</el-button
                >
              <el-popover
                placement="top-start"
                title=""
                trigger="hover"
                content="低于当前值弹窗提示"
              >
                <i
                  slot="reference"
                  class="el-icon-question"
                  style="color: #333; margin-left: 10px"
                ></i>
              </el-popover>
            </div>
          </div>
          <el-button type="primary" style="margin-left: 20px;background-color: #14AACF;border:0;margin-top: 20px;" @click="rechargeBtn(0)">短信充值</el-button>
        </div>
        <div class="text-container" style="background-color:#fff3f1;border: 1px solid #fae1dc;">
          <div class="text-box">
            <span>群发营销短信余额（只能用于群发）：</span>
            <p class="text" style="color: #DD826E;">{{ tableData.batch_num }}条</p>
          </div>
          <el-button type="primary" style="margin-left: 20px;background-color: #DD826E;border:0;margin-top: 20px;" @click="rechargeBtn(1)">群发短信充值</el-button>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        :data="tableData1"
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >

        <el-table-column
          prop="count"
          label="条数"
        > </el-table-column>

        <el-table-column
          prop="amount"
          label="金额"
        > </el-table-column>
        <el-table-column
          prop="mode"
          label="模式"
        > </el-table-column>

        <el-table-column
          prop="description"
          label="描述"
        > </el-table-column>

        <el-table-column
          prop="time_stamp"
          label="时间"
        > </el-table-column>

      </el-table>

      <!-- element ui 原生分页组件 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search_data.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="search_data.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="result_data.count"
        >
        </el-pagination>
      </div>
      <!-- 充值二维码组件 -->
      <rechargeConfig
        :isShow="rechargeConfig_isShow"
        :data="amount"
        :type="type"
        @onSubmit="getMsgCountDetails"
      ></rechargeConfig>


       <!-- 预警值设置组件 -->
       <editAlertNumSubmit :isShow="edit_isShow" :data="alert_num" @onSubmit="onSubmit"> </editAlertNumSubmit>

    </div>
  </template>

  <script>
  var _this;
  import editAlertNumSubmit from './editAlertNumSubmit.vue';
  import rechargeConfig from './rechargeConfig.vue';
  export default {
      components: {
          editAlertNumSubmit,
          rechargeConfig
      },
      name: 'msgCountDetails',
      data() {
          return {
              // 存放表格数据
              tableData1: [],

              type:'',

              alert_num: '',

              edit_isShow: false,

              //翻页数据
              search_data: {
                  page: 1,
                  limit: 10
              },

              result_data: [],

              search_rules: {
                  page: {
                      placeholder: '页码',
                      rules: {
                          required: true,
                          message: '页码需要大于0',
                          regulation: 'gt',
                          rulesData: 0
                      }
                  },
                  limit: {
                      placeholder: '每页个数',
                      rules: {
                          required: true,
                          message: '每页个数需在1-51之内',
                          regulation: 'between',
                          rulesData: [1, 51]
                      }
                  }
              },
              recharge_num_info: false,
              amount: '',
              rechargeConfig_isShow: false,
              tableData: {
                  city: {
                      name: ''
                  },
                  total_count: '',
                  surplus_count: ''
              }
          };
      },
      created() {
          _this = this;
          _this.searchMsgCountLogLists();
          _this.getMsgCountDetails();
          // this.$post('/msg/getMsgCountDetails').then((res) => {
          //     console.log(res.data);
          //     this.tableData = res.data;
          // });
      },
      methods: {
          // 子组件自定义事件
          onSubmit() {
              this.getMsgCountDetails();
          },
          rechargeBtn(type) {
            this.type = type;
              console.log(_this.rechargeConfig_isShow, '_this.rechargeConfig_isShow');
              _this.rechargeConfig_isShow = !_this.rechargeConfig_isShow;



          },
          msgCountLogLists() {
              _this.$post('/msg/msgLog', _this.search_data).then((res) => {
                  _this.result_data = res;
                  _this.tableData1 = res.data;
                  console.log(res, 'res');
              });
          },
          //下拉条（每页显示多少数据）变化
          handleSizeChange(val) {
              // console.log(val, 'val');
              _this.search_data.limit = val;

              //初始化列表
              _this.pages_function();
          },
          //页码变化
          handleCurrentChange(val) {
              _this.search_data.page = val;
              //初始化列表
              _this.pages_function();
          },
          //翻页组件的回调
          pages_function() {
              //初始化列表
              _this.msgCountLogLists();
          },
          searchMsgCountLogLists() {
              _this.search_data.page = 1;
              _this.msgCountLogLists();
          },
          // recharge() {
          //     console.log(_this.amount, '===');
          //     if (Number(_this.amount) >= 0.01 && Number(_this.amount) <= 10000) {
          //         _this.rechargeConfig_isShow = !_this.rechargeConfig_isShow;
          //     } else {
          //         _this.$message.error('短信充值金额为大于0.01小于等于10000的数字！');
          //     }
          // },
          getMsgCountDetails() {
              _this
                  .$post('/msg/getMsgCountDetails')
                  .then((res) => {
                      this.tableData = res.data;
                      _this.amount = '';
                      _this.recharge_num_info = false;
                    console.log(this.tableData,'-----------');



                  })
                  .catch((err) => {});
          }
      }
  };
  </script>

  <style scoped>
  .table{
      margin-top: 10px;
  }
  .service-box,
  .service-box > div {
      display: inline-block;
      margin-left: 10px;
  }
  .service-box > div .service-btn {
      margin-left: 5px;
  }
  .text-box {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px auto;
  }
  .text-box span {
      display: block;
  }

  .text {
      font-size: 16px !important;
      font-weight: 400 !important;
      color: #ff7606;
  }
  .text-container {
    flex: 1;
    background-color: #f5f5f5;
    padding: 30px 0;
    border-radius: 5px;
    /* margin: 10px; */
    text-align: center;
  }
  </style>